import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconInfoInverted = ({ className = '', color = '#000000', height = 18, title, width = 18 }: Icon) => (
    <AccessibleSVG
        className={`icon-info-inverted ${className}`}
        height={height}
        title={title}
        viewBox="0 0 18 18"
        width={width}
    >
        <path
            className="fill-color"
            d="M8.1 13.5h1.8V8.1H8.1v5.4zM9 0C4.05 0 0 4.05 0 9s4.05 9 9 9 9-4.05 9-9-4.05-9-9-9zm0 16.2c-3.96 0-7.2-3.24-7.2-7.2S5.04 1.8 9 1.8s7.2 3.24 7.2 7.2-3.24 7.2-7.2 7.2zm-.9-9.9h1.8V4.5H8.1v1.8z"
            fill={color}
            fillRule="evenodd"
        />
    </AccessibleSVG>
);

export default IconInfoInverted;
